// extracted by mini-css-extract-plugin
export default {"greyDisable":"NextButton_greyDisable__L9rkz"};